import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('SelectDropdownOption', null, { withChildren: true });
